<template lang="html">
  <div :id="sectionId" :class="['list-product', contentClass]">
    <div class="list-product-title mb-2">
      {{ title }}
    </div>
    <v-row>
      <v-col v-for="(item, idx) in items" :key="idx + '-product'" :cols="isList ? 12 : 6" :sm="isList ? 12 : 6" :class="[{ 'py-0' : isList }]">
        <div :class="[`position-relative item-product`, { 'grid': !isList, 'disable': disabled(item) || checkStock(item) || !item.__cart_data.is_available }]" @click="goDetail(item)">
          <div v-if="item.__cart_data.qty > 0" class="vertical-line" />
          <div class="wrap-item-product">
            <div class="item-avatar-product">
              <img v-if="!$isEmpty(defaultVariant(item)) && !isCombo" :src="defaultVariant(item, 'photo_md')" :alt="item.name + ' (' + defaultVariant(item, 'name') + ')'" @error="imageLoadError">
              <img v-else :src="item.photo_md" :alt="item.name" @error="imageLoadError">
            </div>
            <div class="item-content-product">
              <div class="d-flex align-center list-tag-up-selling">
                <div v-if="typeof item.special_attributes !== 'undefined' && !$isEmpty(item.special_attributes) && item.special_attributes.is_popular" class="tag-up-selling tag-user-choice">
                  <div class="tag-up-selling-avatar">
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_4757_14106)">
                        <path d="M1.70766 2.16669H3.70766C4.07566 2.16669 4.33333 2.13202 4.33333 2.50002V1.83335C4.33333 1.46535 4.07566 1.16669 3.70766 1.16669H1.041C0.374328 1.16669 -0.153338 1.87502 0.040995 2.83335C0.040995 2.83335 0.637995 5.95835 0.679995 6.15269C0.790995 6.66669 1.38799 7.16669 2.02699 7.16669H4.34633C4.71466 7.16669 4.33333 6.53469 4.33333 6.16669V5.50002C4.33333 5.86802 4.07566 6.16669 3.70766 6.16669H2.37433C2.00633 6.16669 1.76333 5.81935 1.70766 5.50002C1.652 5.18069 1.17966 3.05569 1.17966 3.05569C1.06866 2.41669 1.33933 2.16669 1.70766 2.16669ZM10.3117 2.16669H8.31166C7.94366 2.16669 7.33333 2.13202 7.33333 2.50002V1.83335C7.33333 1.46535 7.94366 1.16669 8.31166 1.16669H10.9783C11.645 1.16669 12.173 1.87502 11.9783 2.83335C11.9783 2.83335 11.434 5.97302 11.388 6.16669C11.27 6.66669 10.7073 7.16669 10.0547 7.16669H7.67266C7.30466 7.16669 7.33333 6.53469 7.33333 6.16669V5.50002C7.33333 5.86802 7.94366 6.16669 8.31166 6.16669H9.64499C10.013 6.16669 10.2563 5.81935 10.3117 5.50002C10.367 5.18069 10.8397 3.05569 10.8397 3.05569C10.9503 2.41669 10.68 2.16669 10.3117 2.16669ZM6.944 7.83335C6.944 5.51402 6.04099 7.83335 6.04099 7.83335C6.04099 7.83335 5.041 5.51402 5.041 7.83335C5.041 10.1527 3.94399 11.1667 3.94399 11.1667H8.04133C8.041 11.1667 6.944 10.1527 6.944 7.83335Z" fill="#FFAC33" />
                        <path d="M9.70766 2.69233C9.70766 4.95066 7.45099 8.75633 6.04099 8.75633C4.63066 8.75633 2.37433 4.95066 2.37433 2.69233C2.37433 0.96066 2.70766 0.585994 3.37433 0.585994C3.83233 0.585994 5.38266 0.576994 6.04099 0.576994L8.37433 0.576661C9.34666 0.576327 9.70766 0.80466 9.70766 2.69233Z" fill="#FFCC4D" />
                        <path d="M9 11.5C9 11.868 9.07567 12.1667 8.70767 12.1667H3.37433C3.006 12.1667 3 11.868 3 11.5V11.1667C3 10.7987 3.388 10.5 3.73533 10.5H8.37433C8.72167 10.5 9 10.7987 9 11.1667V11.5Z" fill="#C1694F" />
                        <path d="M9.66668 12.0417C9.66668 12.295 9.72168 12.5 9.24934 12.5H2.83268C2.40201 12.5 2.33334 12.295 2.33334 12.0417V11.9583C2.33334 11.705 2.57934 11.5 2.83268 11.5H9.24934C9.50234 11.5 9.66668 11.705 9.66668 11.9583V12.0417Z" fill="#C1694F" />
                      </g>
                      <defs>
                        <clipPath id="clip0_4757_14106">
                          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="tag-up-selling-content">
                    {{ $t('v2.user_choice') }}
                  </div>
                </div>
                <div v-if="typeof item.special_attributes !== 'undefined' && !$isEmpty(item.special_attributes) && item.special_attributes.is_discount" class="tag-up-selling tag-discount">
                  <div class="tag-up-selling-avatar">
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_4757_51)">
                        <path d="M8.91701 3.16905C9.37167 3.62405 10.0383 3.73838 10.599 3.51305L11.8033 4.71671C12.049 4.96338 12.0493 5.36271 11.802 5.61005L5.10634 12.3017C4.85867 12.548 4.45967 12.5474 4.21267 12.3017L3.01067 11.0977C3.23467 10.5364 3.12067 9.87038 2.66667 9.41538C2.21101 8.96038 1.54534 8.84638 0.98434 9.07138L0.198006 8.28471C-0.0486602 8.03905 -0.0493269 7.63871 0.198006 7.39138L6.89267 0.698714C7.13901 0.452047 7.53801 0.451714 7.78567 0.69938L8.57267 1.48638C8.34701 2.04738 8.46234 2.71338 8.91701 3.16905Z" fill="#EA596E" />
                        <path d="M1.80667 6.6757L1.09034 7.3917C0.844005 7.63803 0.843338 8.03803 1.08934 8.28503L1.27 8.46536C1.902 8.29703 2.603 8.45936 3.09734 8.9547C3.59334 9.45003 3.75434 10.151 3.58634 10.7817L4.21234 11.4094C4.45934 11.6557 4.85934 11.6557 5.10634 11.4087L5.836 10.6797L1.80667 6.6757ZM6.31367 10.2024L9.69967 6.81836L5.66934 2.81436L2.28467 6.19836L6.31367 10.2024ZM6.977 5.53803C7.72534 6.2807 7.892 7.32336 7.35067 7.8677C6.80834 8.4127 5.76334 8.25136 5.017 7.50936C4.27067 6.7667 4.10434 5.72336 4.64567 5.17903C5.18734 4.6357 6.23067 4.7957 6.977 5.53803ZM10.9103 4.7167L10.2833 4.0897C9.65167 4.25736 8.95067 4.0967 8.45567 3.60036C7.95967 3.1057 7.797 2.40336 7.96567 1.77236L7.78534 1.59036C7.53867 1.34536 7.13867 1.34536 6.89267 1.59136L6.14734 2.3367L10.178 6.34036L10.91 5.6087C11.1567 5.36303 11.1567 4.96336 10.9103 4.7167Z" fill="#BE1931" />
                      </g>
                      <defs>
                        <clipPath id="clip0_4757_51">
                          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="tag-up-selling-content">
                    {{ $t('v2.there_promotion') }}
                  </div>
                </div>
              </div>
              <div :class="[`item-title-product`, { 'font-weight-700 ol-brand': item.__cart_data.qty > 0 }]">
                {{ item.__cart_data.qty > 0 ? item.__cart_data.qty + 'x' : '' }} {{ item.name }}
              </div>
              <div v-if="typeof item.special_attributes !== 'undefined' && !$isEmpty(item.special_attributes) && typeof item.special_attributes.sale_count !== 'undefined'" class="item-qty-sold">
                {{ $t('v2.sold', { qty: item.special_attributes.sale_count }) }}
              </div>
              <div v-if="checkStock(item) || !item.__cart_data.is_available" class="item-price-product is-out-stock">
                {{ $t('v2.out_of_stock') }}
              </div>
              <template v-else>
                <div v-if="Number(item.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0" class="item-price-product order-at-cashier">
                  {{ $t('v2.order_at_cashier') }}
                </div>
                <div v-else class="item-price-product d-flex align-center">
                  <span v-if="$usePosPrice()" v-mask-money="item.sell_price_pos" />
                  <span v-else v-mask-money="item.sell_price" />
                  <div v-if="Number(item.market_price) !== 0" class="d-flex align-center">
                    <span v-mask-money="item.market_price" class="market-price" />
                    <div class="ml-1">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1C5.6325 1 5.76 1.0525 5.8535 1.1465L10.8535 6.1465C11.049 6.342 11.049 6.658 10.8535 6.8535L6.8535 10.8535C6.756 10.951 6.628 11 6.5 11C6.372 11 6.244 10.951 6.1465 10.8535L1.1465 5.8535C1.0525 5.76 1 5.633 1 5.5V3C1 2.867 1.0525 2.74 1.1465 2.6465L2.6465 1.1465C2.74 1.0525 2.8675 1 3 1H5.5ZM2 5.293L6.5 9.793L9.793 6.5L5.293 2H3.207L2 3.207V5.293ZM5.00003 4.1765C5.00003 4.6313 4.63133 5 4.17653 5C3.72172 5 3.35303 4.6313 3.35303 4.1765C3.35303 3.72169 3.72172 3.353 4.17653 3.353C4.63133 3.353 5.00003 3.72169 5.00003 4.1765Z" fill="#F44336" />
                      </svg>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <hr v-if="isList" class="line-product">
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    isList: {
      default: false,
      type: Boolean
    },
    title: {
      required: true,
      type: String
    },
    items: {
      required: true,
      type: Array
    },
    clickDetail: {
      required: true,
      type: Function
    },
    isCombo: {
      default: false,
      type: Boolean
    },
    sectionId: {
      required: true,
      type: String
    },
    contentClass: {
      default: '',
      type: String
    }
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    disabled() {
      if (!this.$isEmpty(this.$store.state.selected_outlet)) {
        const openStore = this.$store.state.selected_outlet.store_is_open === 1
        if (!openStore) {
          return true
        } else {
          if (this.$store.state.selected_type === 'DINE-IN' && this.$store.state.selected_outlet.setting.use_dinein === 1) {
            return false
          } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY' && this.$store.state.selected_outlet.setting.use_takeaway === 1) {
            return false
          } else if (this.$store.state.selected_type === 'DELIVERY' && this.$store.state.selected_outlet.setting.use_delivery === 1) {
            return false
          } else if (this.$store.state.selected_type === 'RESERVATION' && this.$store.state.selected_outlet.setting.use_reservation === 1) {
            return false
          } else {
            return true
          }
        }
      } else {
        return true
      }
    },
    async goDetail(item) {
      if (!this.disabled(item)) {
        await this.clickDetail(item)
      }
    },
    defaultVariant(item, value = '') {
      if (!this.isCombo) {
        const arrayData = item.variants
        const variant = arrayData.findIndex(obj => {
          return obj.id === item.default_variant_id
        })
        if (variant !== -1) {
          if (value !== '') {
            return item.variants[variant][value]
          } else {
            return item.variants[variant]
          }
        } else {
          return {}
        }
      } else {
        return {}
      }
    },
    // isOutStock() {
    //   if (typeof this.detail_product.item.items !== 'undefined') {
    //     if (this.detail_product.item.is_out_stock) {
    //       return true
    //     }
    //   } else {
    //     if (this.detail_product.item.has_variant) {
    //       let isDisabled = true
    //       for (let i = 0; i < this.detail_product.item.variants.length; i++) {
    //         const item = this.detail_product.item.variants[i]
    //         if (!item.is_out_stock && Number(item.hold_qty) + this.stockCart(item.id, 'variant') < Number(item.stock_qty)) {
    //           isDisabled = false
    //           break
    //         }
    //       }
    //       return isDisabled
    //       // if (isAvailable) {}
    //     } else {
    //       if (this.detail_product.item.track_inventory) {
    //         if (this.detail_product.item.is_out_stock || this.stockCart(this.detail_product.item.id) + Number(this.detail_product.item.hold_qty) >= Number(this.detail_product.item.stock_qty)) {
    //           return true
    //         }
    //       } else {
    //         if (this.detail_product.item.is_out_stock) {
    //           return true
    //         }
    //       }
    //     }
    //   }
    //   return false
    // },
    checkStock(item) {
      if (typeof item.items !== 'undefined') {
        if (item.is_out_stock) {
          return true
        }
      } else {
        if (item.has_variant) {
          let isDisabled = true
          for (let i = 0; i < item.variants.length; i++) {
            const variant = item.variants[i]
            if (item.track_inventory) {
              if (!variant.is_out_stock && Number(variant.hold_qty) + this.$stockCart(variant.id, '_v2_cart', 'variant') < Number(variant.stock_qty)) {
                isDisabled = false
                break
              }
            } else {
              if (!variant.is_out_stock) {
                isDisabled = false
                break
              }
            }
          }
          return isDisabled
        } else {
          if (item.track_inventory) {
            if (item.is_out_stock || this.$stockCart(item.id) + Number(item.hold_qty) >= Number(item.stock_qty)) {
              return true
            }
          } else {
            if (item.is_out_stock) {
              return true
            }
          }
        }
      }
      return false
    }
  }
}
</script>
<style>
  .list-product {
    margin-top: 24px;
  }
  .list-product:not(:last-child){
    margin-bottom: 8px;
  }
  .list-product-title{
    font-size: 20px;
    font-weight: 700;
    color: #272727;
  }
  .item-product {
    margin: 0 -12px;
  }
  .wrap-item-product{
    padding: 12px;
    cursor: pointer;
  }
  .wrap-item-product {
    padding: 12px;
    cursor: pointer;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    letter-spacing: normal;
    outline: none;
    position: relative;
    text-decoration: none;
  }
  .item-avatar-product {
    width: 112px;
    height: 112px;
    -ms-flex-item-align: start;
    align-self: flex-start;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: normal;
    position: relative;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
    margin-right: 16px;
  }
  .item-avatar-product > img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
  }
  .item-content-product{
    -ms-flex-item-align: start;
    align-self: flex-start;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1;
    overflow: hidden;
  }
  .item-title-product {
    flex: 1 1 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    white-space: normal;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 16px;
    color: #272727;
    font-weight: 400;
    line-height: 21.82px;
  }
  .item-price-product{
    font-size: 16px;
    font-weight: 700;
    color: #272727;
    margin-top: 8px;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
  }
  .item-qty-sold{
    margin-top: 8px;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    color: #767676;
    font-size: 11px;
  }
  .item-price-product.order-at-cashier{
    color: #a0a0a0;
    font-style: italic;
  }
  .item-price-product .market-price{
    color: #a0a0a0;
    text-decoration: line-through;
    margin-left: 8px;
    font-size: 14px;
  }
  .item-product.grid .item-price-product .market-price{
    display: block;
    margin-left: 0px;
  }
  .line-product{
    width: calc(100% - 24px);
    margin: auto;
    border: none;
    border-width: thin 0 0;
    height: 0.5px;
    background-color: #CECECE;
  }
  .item-product.grid {
    margin: 0px;
    border-radius: 8px;
    -webkit-box-shadow: 0px 2px 2px 0px #0000001f;
    box-shadow: 0px 2px 2px 0px #0000001f;
    height: 100%;
  }
  .item-product.grid .wrap-item-product{
    padding: 0px;
    flex-direction: column;
  }
  .item-product.grid .item-avatar-product{
    margin-right: 0px;
    display: block;
    width: 100%;
    height: auto;
    position: relative;
    overflow: hidden;
    padding: 95% 0 0 0;
  }
  .item-product.grid .item-avatar-product > img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto auto;
    width: 100%;
    height: 100%;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  .item-product.grid .item-content-product{
    padding: 0px 8px 8px;
  }
  .item-product.grid .list-tag-up-selling{
    margin-top: 8px;
  }
  .list-tag-up-selling{
    margin-bottom: 8px;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
  }
  .item-product.disable .wrap-item-product{
    pointer-events: none;
    cursor: not-allowed;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none;
  }
  .item-product.disable img{
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%)
  }
  .item-product.disable .item-avatar-product{
    opacity: .64;
  }
  .item-product.disable .item-title-product{
    color: #767676;
  }
  .item-product.disable .item-price-product{
    color: #767676;
  }
  .item-price-product.is-out-stock, .item-product.disable .item-price-product.is-out-stock {
    color: #F44336;
  }
  .vertical-line {
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 4px;
    background: linear-gradient(90deg, #0078CE 0%, #0B94F5 100%);
  }
  .item-product.grid .tag-up-selling{
    padding: 0px 8px;
  }
  .tag-up-selling {
    display: flex;
    align-items: center;
    padding: 0px 10px;
    border-radius: 100px;
  }
  .tag-up-selling.tag-user-choice{
    background-color: #FFF2E3;
  }
  .tag-up-selling.tag-discount{
    background-color: #FEE8E6;
    margin-left: 4px;
  }
  .tag-up-selling-content {
    font-size: 11px;
    font-weight: 700;
    margin-left: 4px;
    line-height: normal;
  }
  .tag-up-selling.tag-user-choice .tag-up-selling-content{
    color: #F0820A;
  }
  .tag-up-selling.tag-discount .tag-up-selling-content{
    color: #F44336;
  }
</style>
